import { useCallback, useState } from "react";

/**
 * @returns {number} reloadToken - include in an effect's deps; bumping it forces a refetch
 * @returns {() => void} retry - bumps reloadToken (used by retry after a failed load)
 */
export function useReloadToken() {
  const [reloadToken, setReloadToken] = useState(0);
  const retry = useCallback(() => setReloadToken((token) => token + 1), []);

  return { reloadToken, retry };
}
